export const getSubeventId = (subeventMeta: {
  inPlaySubeventId: number;
  preMatchSubeventId: number;
  startTime: string;
}) => {
  const currentDatetime = new Date();
  const isInPlay = currentDatetime >= new Date(subeventMeta.startTime);
  const subeventId = isInPlay ? subeventMeta.inPlaySubeventId : subeventMeta.preMatchSubeventId;

  return subeventId;
};
